
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpStaticVertical as ObiPumpStaticVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-static-vertical.js';
 
 
 

 
 export const ObiPumpStaticVertical = createComponent({
   react: React,
   tagName: 'obi-pump-static-vertical',
   elementClass: ObiPumpStaticVerticalElement,
   events: {
     
   }
  });
 
 